import { Button, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/lab/Alert";
import { type SyntheticEvent, useState } from "react";

import { ButtonWithLoading, ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { deleteForm } from "../../../repositories/FormsRepository";
import { useFormsContext } from "../../../context/FormsContext";

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
	searchData: Function;
};

export const DeleteFormDialog = ({ show, onHide, searchData }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [formRemovedSuccess, setFormRemovedSuccess] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");
	const {
		state: {
			formSelectedInTable: { FormId, FormName },
		},
	} = useFormsContext();

	const handleCancel = () => {
		setIsSubmitLoading(false);
		onHide(false);
	};

	const handleClose = (
		event: Event | React.SyntheticEvent,
		reason?: string,
	) => {
		if (reason === "clickaway") {
			return;
		}
		setFormRemovedSuccess(false);
	};

	const handleRemoveForm = async () => {
		setIsSubmitLoading(true);
		const res = await deleteForm(FormId as number);
		if (res.ok) {
			setFormRemovedSuccess(true);
			setIsSubmitLoading(false);
			onHide(false);
			searchData();
		} else {
			setError(res.message);
			setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<MesfModal
				title="DELETE FORM"
				open={show}
				handleClose={() => handleCancel()}
				maxWidth="sm"
				id="delete-form-modal"
			>
				<MesfModal.Content dividers>
					<Typography>
						Delete <b>{FormName}</b>? Once deleted it cannot be recovered.
					</Typography>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 16px 16px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end" width="100%">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }}>
							<ButtonWithLoading
								fullWidth
								isLoading={isSubmitLoading}
								variant="contained"
								color="secondary"
								onClick={handleRemoveForm}
							>
								Delete
							</ButtonWithLoading>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<Snackbar
				open={formRemovedSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="info" onClose={handleClose}>
					Form removed succesfully
				</Alert>
			</Snackbar>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
